<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      inactivityTimer: null,
      inactivityTimeout: 30 * 60 * 1000, // 30분 (밀리초)
      activityEvents: ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'],
      lastActivityTime: Date.now(),
      throttleDelay: 1000 // 1초마다만 타이머 리셋 (성능 최적화)
    }
  },
  mounted() {
    this.setupInactivityDetection();
  },
  beforeUnmount() {
    this.removeInactivityDetection();
  },
  methods: {
    // 일반 사용자 로그인 상태 확인 (관리자 제외)
    isShopUserLoggedIn() {
      // 관리자 토큰이 있으면 제외
      const adminToken = localStorage.getItem('adminToken');
      const adminUser = localStorage.getItem('adminUser');
      if (adminToken || adminUser) {
        return false; // 관리자는 자동 로그아웃 대상 아님
      }

      // 일반 사용자 토큰 확인
      const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
      return !!token;
    },

    // 비활동 감지 설정
    setupInactivityDetection() {
      // 바인딩된 핸들러 저장 (제거 시 필요)
      this.boundActivityHandler = this.handleUserActivity.bind(this);

      // 활동 이벤트 리스너 추가
      this.activityEvents.forEach(event => {
        document.addEventListener(event, this.boundActivityHandler, { passive: true });
      });

      // 초기 타이머 시작
      this.startInactivityTimer();
    },

    // 비활동 감지 제거
    removeInactivityDetection() {
      // 타이머 클리어
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
        this.inactivityTimer = null;
      }

      // 이벤트 리스너 제거
      if (this.boundActivityHandler) {
        this.activityEvents.forEach(event => {
          document.removeEventListener(event, this.boundActivityHandler);
        });
      }
    },

    // 사용자 활동 핸들러 (쓰로틀링 적용)
    handleUserActivity() {
      const now = Date.now();

      // 쓰로틀링: 마지막 활동 후 1초 이내면 무시
      if (now - this.lastActivityTime < this.throttleDelay) {
        return;
      }

      this.lastActivityTime = now;
      this.startInactivityTimer();
    },

    // 비활동 타이머 시작/리셋
    startInactivityTimer() {
      // 로그인 상태가 아니면 무시
      if (!this.isShopUserLoggedIn()) {
        return;
      }

      // 기존 타이머 클리어
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }

      // 새 타이머 시작 (30분 후 자동 로그아웃)
      this.inactivityTimer = setTimeout(() => {
        this.handleInactivityLogout();
      }, this.inactivityTimeout);
    },

    // 비활동으로 인한 자동 로그아웃
    handleInactivityLogout() {
      // 로그인 상태가 아니면 무시
      if (!this.isShopUserLoggedIn()) {
        return;
      }

      console.log('30분간 활동이 없어 자동 로그아웃됩니다.');

      // 토큰 및 사용자 정보 삭제
      localStorage.removeItem('auth_token');
      localStorage.removeItem('token');
      localStorage.removeItem('user_info');
      localStorage.removeItem('user');

      // 세션 만료 알림
      alert('장시간 활동이 없어 자동 로그아웃되었습니다.\n다시 로그인해 주세요.');

      // 로그인 페이지로 이동
      if (this.$router) {
        this.$router.push('/login');
      } else {
        window.location.href = '/login';
      }
    }
  },
  watch: {
    // 라우트 변경 시에도 타이머 리셋 (페이지 이동도 활동으로 간주)
    '$route'() {
      if (this.isShopUserLoggedIn()) {
        this.startInactivityTimer();
      }
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
